// Minimal RFC-4180-ish CSV parser — handles quoted fields (with embedded
// commas, newlines, and escaped "" quotes) and both \r\n and \n line endings.
// No dependency needed for something this small and self-contained.
export const parseCsv = (text) => {
    const rows = [];
    let row = [];
    let field = "";
    let inQuotes = false;

    const pushField = () => {
        row.push(field);
        field = "";
    };
    const pushRow = () => {
        pushField();
        rows.push(row);
        row = [];
    };

    for (let i = 0; i < text.length; i++) {
        const char = text[i];

        if (inQuotes) {
            if (char === '"') {
                if (text[i + 1] === '"') {
                    field += '"';
                    i += 1;
                } else {
                    inQuotes = false;
                }
            } else {
                field += char;
            }
            continue;
        }

        if (char === '"') {
            inQuotes = true;
        } else if (char === ",") {
            pushField();
        } else if (char === "\r") {
            // swallow — the following \n (if any) triggers the row push
        } else if (char === "\n") {
            pushRow();
        } else {
            field += char;
        }
    }

    // Final field/row if the file doesn't end with a newline
    if (field.length > 0 || row.length > 0) {
        pushRow();
    }

    return rows.filter((r) => !(r.length === 1 && r[0] === ""));
};

// Parses CSV text into an array of objects keyed by the header row.
export const parseCsvToObjects = (text) => {
    const rows = parseCsv(text);
    if (!rows.length) return [];

    const headers = rows[0].map((h) => h.trim());
    return rows.slice(1).map((row) =>
        headers.reduce((obj, header, idx) => {
            obj[header] = (row[idx] ?? "").trim();
            return obj;
        }, {}),
    );
};
